const regulationParams = { 
    sort : "?sort[0]=id%3Aasc",
    populate: "&populate=%2A",
}

export default regulationParams;